import React from "react";

// COMPONENTS
import KOGPaginationGrid from "@/main/components/shared/paginationGrid/paginationGrid";
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";

// REDUX / UTILS
import { getTranslateByKey } from "@/main/services/utils";
import { procurementReportApi } from "@/main/api";
import { RowHeaderTextCenter } from "@/main/components/shared/styles";

// COMPONENTS & STYLES LOCAL
import * as S from "./styles";
import { ResolutionsEnum } from "@/main/services/enum/ResolutionsEnum";
import { DynamicReportGridResponse } from "@/main/models/response/dynamicReportResponse";
import { DynamicReportGridRequest } from "@/main/models/request/dynamicReportGridRequest";
import RowDataDynamicReport from "./rowDynamicReport/rowDynamicReport";

interface IGridDynamicReportProps {
	dataGrid: DynamicReportGridResponse[];
	formFilters: DynamicReportGridRequest | null;
	setDataGrid: React.Dispatch<React.SetStateAction<DynamicReportGridResponse[]>>;
	getData: (filters: DynamicReportGridRequest | Partial<DynamicReportGridRequest>, isResetSearch: boolean) => void;
}
function GridDynamicReport({ dataGrid, formFilters, setDataGrid, getData }: IGridDynamicReportProps) {
	const rowsHeader = [
		getTranslateByKey("information.name"),
		getTranslateByKey("information.lastUpdate"),
		getTranslateByKey("information.status"),
		<RowHeaderTextCenter key="3">{getTranslateByKey("information.actions")}</RowHeaderTextCenter>,
	];
	// const rowsGroup = [
	//   '10%', // insurer
	//   '10%', // bodyshop
	//   '10%', // vehicle
	//   '10%', // supplier
	//   '10%', // startDate
	//   '10%', // finalDate
	//   'responsive', // username
	//   '15%', // date
	//   '120px',// actions
	//   // '30%',
	// ]
	async function fetchData(request: any) {
		return procurementReportApi.dynamicReportSearchGrid(request).then((response) => response.data);
	}

	function refreshGrid() {
		getData({}, false);
	}

	return (
		<S.Container>
			<KOGPaginationGrid
				showTitleResults
				dataGrid={dataGrid}
				formFilters={formFilters}
				setDataGrid={setDataGrid}
				fetchMore={fetchData}
			>
				<BoxGrid
					rowHeaders={rowsHeader}
					//sizeColumns={rowsGroup}
					breakpointTable={ResolutionsEnum.desktop}
				>
					{dataGrid.map((item) => (
						<RowDataDynamicReport key={item.guidDynamicReport} refreshGrid={refreshGrid} scheduleReport={item} />
					))}
				</BoxGrid>
			</KOGPaginationGrid>
		</S.Container>
	);
}
export default GridDynamicReport;
